import { useTranslation } from "react-i18next";
import Box from "@mui/material/Box";
import { Divider, styled } from "@mui/material";

const HeaderText = styled("p")({
  fontSize: "16px",
  fontWeight: 700,
  lineHeight: "24px",
});

const CustomDivider = styled(Divider)(({ theme }) => ({
  marginTop: "16px",
  borderColor: "#cccccc",
}));

const PaymentMethods = () => {
  const { t } = useTranslation();

  return (
    <Box>
      <HeaderText>{t("paymentMethods")}</HeaderText>
      <CustomDivider />
      <div
        style={{
          minHeight: "calc(100dvh - 500px)",
          height: "100%",
        }}
      >
        <h3
          style={{
            marginTop: "20px",
          }}
        >
          {t("onWebsiteYouCanBuyWith")}
        </h3>

        <p>{t("withVisaOrMaster")}</p>
        <p>{t("onlineInstallment")}</p>
      </div>
    </Box>
  );
};

export default PaymentMethods;
